import React, { useRef, useEffect } from 'react';
import { useStyles } from './styles';
// import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, BorderColorRounded } from '@material-ui/icons';
import clsx from 'clsx';
import Player from '@vimeo/player';
import { useHistory, useLocation } from 'react-router-dom';

var sync = null;
const MIN_WATCH_PERCENT_TO_FINISH = 0.5;
const MAX_CONTIGUOUS_PROGRESS_SECONDS = 2;

function VimeoPlayer({ onTimeupdate, onEnded, hideAnotation, ...attrs }) {
  const ref = useRef(null);

  React.useEffect(() => {
    if (hideAnotation) {
      hideAnotation(false);
    }
  }, []);

  useEffect(() => {
    /**
     * The events to Player are in Vimeo Docs.
     * https://developer.vimeo.com/player/sdk/reference#events-for-playback-controls
     */
    const player = new Player(ref.current);
    player.on('timeupdate', onTimeupdate);
    player.on('ended', onEnded);
    return () => player.off('ended', onEnded);
  }, []);
  return <iframe ref={ref} {...attrs} allow="autoplay; encrypted-media" />;
}

export default ({
  finishedCourse,
  content,
  video_time,
  courseFinished,
  courseId,
  learnId,
  prev,
  next,
}) => {
  // const { t } = useTranslation(['title', 'label', 'form', 'button', 'cards']);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const watchedRangesRef = useRef([]);
  const durationRef = useRef(0);
  const lastPlaybackSecondRef = useRef(null);
  const maxTrustedSecondRef = useRef(0);

  const getWatchedDuration = (ranges) =>
    ranges.reduce((total, [start, end]) => total + (end - start), 0);

  const addWatchedRange = (start, end) => {
    const safeStart = Math.max(0, start);
    const safeEnd = Math.max(0, end);

    if (safeEnd <= safeStart) return;

    const ranges = [...watchedRangesRef.current, [safeStart, safeEnd]].sort(
      (a, b) => a[0] - b[0]
    );
    const merged = [];

    ranges.forEach(([rangeStart, rangeEnd]) => {
      const lastRange = merged[merged.length - 1];

      if (!lastRange || rangeStart > lastRange[1]) {
        merged.push([rangeStart, rangeEnd]);
        return;
      }

      lastRange[1] = Math.max(lastRange[1], rangeEnd);
    });

    watchedRangesRef.current = merged;
  };

  const hasReachedMinimumWatchTime = () => {
    const duration = durationRef.current;

    if (!duration || duration <= 0) return false;

    const watchedDuration = getWatchedDuration(watchedRangesRef.current);
    return watchedDuration >= duration * MIN_WATCH_PERCENT_TO_FINISH;
  };

  useEffect(() => {
    return () => clearTimeout(sync);
  }, []);

  useEffect(() => {
    clearTimeout(sync);
    durationRef.current = 0;
    lastPlaybackSecondRef.current = null;
    maxTrustedSecondRef.current = video_time && video_time > 0 ? Number(video_time) : 0;
    watchedRangesRef.current =
      video_time && video_time > 0 ? [[0, Number(video_time)]] : [];
  }, [content?.url_vimeo, video_time]);

  const timeUpdate = (timePlayback) => {
    clearTimeout(sync);

    const currentSecond = Number(timePlayback?.seconds || 0);
    const currentDuration = Number(timePlayback?.duration || 0);

    if (currentDuration > 0) {
      durationRef.current = currentDuration;
    }

    if (lastPlaybackSecondRef.current != null) {
      const delta = currentSecond - lastPlaybackSecondRef.current;

      if (delta > 0 && delta <= MAX_CONTIGUOUS_PROGRESS_SECONDS) {
        addWatchedRange(lastPlaybackSecondRef.current, currentSecond);
        maxTrustedSecondRef.current = Math.max(maxTrustedSecondRef.current, currentSecond);
      }
    }

    lastPlaybackSecondRef.current = currentSecond;

    const trustedCurrentSecond = Math.min(currentSecond, maxTrustedSecondRef.current);
    const isEndPlayback = timePlayback?.percent === 1;
    const finished = courseFinished ? true : hasReachedMinimumWatchTime();

    sync = setTimeout(() => {
      const videoLastSec = parseInt(trustedCurrentSecond - (finished ? 0 : 10));

      finishedCourse({
        finished: finished,
        video_last_sec: videoLastSec > 0 ? videoLastSec : 0,
        audio_last_sec: null,
        isEndPlayback,
      });
    }, 400);
  };

  // const scrollToContent = () => {
  //   const scrollOffset = 500;
  //   const targetElement = document.getElementById('elementId'); // Substitua 'elementId' pelo ID real do elemento

  //   if (targetElement) {
  //     targetElement.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'end', // ou 'end' para rolar até a parte inferior do elemento
  //     });
  //   }
  // };

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>{content.name}</h1>
      <div className={classes.wrapper}>
        <VimeoPlayer
          title="vimeo-player"
          src={`${window._env_.REACT_APP_VIMEO_DOMAIN
            }${content.url_vimeo.replace(
              '/videos',
              '/video'
            )}#t=${video_time}s?portrait=0&byline=0&title=0`}
          t
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          onTimeupdate={timeUpdate}
          onEnded={timeUpdate}
        />
      </div>

      <div className={classes.buttons}>
        <button
          onClick={() => history.push(`/course/${courseId}/learn/${prev}${location.search || ''}`)}
          disabled={prev == null}
        >
          {' '}
          <ChevronLeft /> Anterior
        </button>
        {/* <button onClick={scrollToContent}>
          <BorderColorRounded>
          </BorderColorRounded>
        </button> */}
        <button
          style={{ right: 10 }}
          onClick={() => history.push(`/course/${courseId}/learn/${next}${location.search || ''}`)}
          disabled={next == null}
          className={clsx([classes.buttonsActive])}
        >
          Próximo <ChevronRight />
        </button>
      </div>
    </div>
  );
};
